import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from './env.service';

export interface ICredentials {
  usuario: string;
  clave: string;
  createdAt?: Date;
  updatedAt?: Date;
  id?: number;
}

@Injectable({
  providedIn: 'root',
})
export class CredentialsADService {
  url = `${this.env.URL_API}/credencialesAD`;
  constructor(public http: HttpClient, private env: EnvService) { }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  get(): Observable<any> {
    return this.http.get(this.url);
  }

  post(credentials: ICredentials): Observable<any> {
    return this.http.post(this.url, credentials);
  }
}
